import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const CollapsibleClassName = `${CLASS_NAME_PREFIX}-collapsible`;
export const CollapsibleHeaderClassName = `${CollapsibleClassName}__header`;
export const CollapsibleContentClassName = `${CLASS_NAME_PREFIX}__content`;
